'use strict';
const angular = require('angular');

import model from './common-images.model.html';
import fileUploadModel from '../../components/modal/FileUpload.html';

const uiRouter = require('angular-ui-router');
import routes from './common-images-center.routes';

export class CommonImagesCenterComponent {
    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
        this.api = '/api/common-images-centers';
    }

    $onInit() {
        this.$http.get(this.api)
            .then(response => {
                if(response.data.data) {
                    this.columns = response.data.data;
                    this.totalCount = response.data.data.length;
                }
            });
    }

    createOne() {
        const that = this;
        this.$uibModal.open({
            template: model,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.title = '新建';
                $scope.vm = {};
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post(that.api, $scope.vm).then(() => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };

                $scope.uploadAndGetUrl = that.uploadAndGetUrl(that, $scope.vm);
            }
        });
    }

    uploadAndGetUrl(which, rewrite) {
        return () => which.$uibModal.open({
            template: fileUploadModel,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = {};
                $scope.isUpping = false;
                $scope.isUppingError = false;
                const uploader = $scope.imageUploader = new FileUploader({
                    url: '/api/share_imgs/9528/',
                    method: 'POST',
                    autoUpload: true,
                });
                uploader.onSuccessItem = function(fileItem, response, status, headers) {
                    if(status === 200) {
                        $scope.isUpping = false;
                        $scope.vm.url = response.data.small_img;
                    }
                };
                uploader.filters.push({
                    name: 'Filter',
                    fn(item, options) {
                        $scope.vm.size = item.size;
                        $scope.vm.type = item.type;
                        if(item.type.indexOf('image') !== -1) {
                            $scope.isUpping = true;
                            $scope.isUppingError = false;
                            return true;
                        } else {
                            $scope.isUppingError = true;
                            return false;
                        }
                    }
                });
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };
                $scope.back = function() {
                    const img = document.getElementById('uploader');
                    console.log(img.naturalWidth, img.naturalHeight);
                    if(img.naturalWidth > 0 && img.naturalHeight > 0) {
                        Object.assign(rewrite, $scope.vm);
                        $uibModalInstance.close();
                    } else {
                        alert('正在获取大小');
                    }
                };
                $scope.showInfo = function() {
                    const img = document.getElementById('uploader');
                    if(img.naturalWidth > 0 && img.naturalHeight > 0) {
                        $scope.vm.naturalWidth = img.naturalWidth;
                        $scope.vm.naturalHeight = img.naturalHeight;
                    }
                };
            }
        });
    }

    delete(ad) {
        this.$http.delete(`${this.api}/${ad._id}`).then(() => {
            this.$onInit();
        });
    }

    edit(ad) {
        const that = this;
        this.$uibModal.open({
            template: model,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.title = '编辑';
                $scope.vm = ad;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post(that.api, $scope.vm).then(() => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };
                $scope.uploadAndGetUrl = that.uploadAndGetUrl(that, $scope.vm);
            }
        });
    }
}

export default angular.module('tttApp.common-images-center', [uiRouter])
    .config(routes)
    .component('commonImagesCenter', {
        template: require('./common-images-center.html'),
        controller: CommonImagesCenterComponent,
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/common-images-center/common-images-center.component.js